export default "__VITE_ASSET__CVOwWQOm__"